<div class="partslookup-dialog">
  <div class="partslookup-dialog-header flex-between-center header-icon font-white">
    <p class="m-0 font-18 font-700">
      <img src="../../../../assets/img/lookup-dark-header.svg" alt="" />
      <span class="font-bold pl-2 pt-1">Magic Part Lookup unavailable</span>
    </p>
    <span class="close-modal font-white">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="partslookup-dialog-body flex-column partslookup-dialog-body-no-record mb-2">
    <ng-container>
      <div class="message-box-wrapper">
        <div class="message-box">
          <div class="flex-center-center" hidden>
            <img src="../../../../assets/img/errorIcon.svg" width="10%" class="flex-center-center" />
          </div>
          <p style="padding-top: 20px" class="main-text">To use Magic Part Lookup, you first need to configure a parts ordering integration</p>
          <ul>
            <li>
              <span class="font-14 font-700">To get started:</span>
              Go to Settings > Integrations > Part Ordering and set up
              <a routerLink="/settings/integrations/parts-ordering" [queryParams]="{ integrationType: 'partstech' }" target="_blank" class="font-600 font-primarypointer">
                <span class="font-14 font-700">PartsTech</span>
              </a>
              or
              <a routerLink="/settings/integrations/parts-ordering" [queryParams]="{ integrationType: 'nexpart' }" target="_blank" class="font-600 font-primarypointer">
                <span class="font-14 font-700">Nexpart</span> </a
              >.
            </li>
            <li>
              <span class="font-14 font-700">Once configured:</span>
              Go to Settings > Integrations > Magic Services and choose your preferred provider for part lookup and online ordering.
            </li>
          </ul>
        
          <div>
            Need help? Contact Support to get assistance setting up your part ordering integration
          </div>
        </div>
        
      </div>
    </ng-container>

    <!-- OTHER LIST END -->
  </div>

  <div class="partslookup-dialog-footer flex-end-center">
    <div>
      <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
      <button class="btn btn-light-primary mr-2 part-tech-btn" (click)="redirectToPartsTechConnection()" tooltipPosition="top" [pTooltip]="'Connect to order from PartsTeh'">
        Go to Integration Settings
      </button>
    </div>
  </div>
</div>
